import React from "react";
import { Route, Switch } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Theme from "../components/Theme";
import ProtectedRoutes from "../components/Auth/protectedRoutes";
import MainLayout from "./MainLayout";
import Login from "../containers/Authentication/loginContainer";
import VerifyAccount from "../screens/Authentication/verify-account";

class App extends React.Component {
  render() {
    return (
      <MuiThemeProvider theme={Theme}>
        <Switch basename={"/"}>
          <Route path="/login" component={Login} />
          <Route path="/verify" component={VerifyAccount} />
          <ProtectedRoutes path={"/"} component={MainLayout} />
        </Switch>{" "}
      </MuiThemeProvider>
    );
  }
}

export default App;
